import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  container: {
    width: 'calc(100% - 2px)',
    padding: '8px 10px',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    boxSizing: 'border-box',
    borderRadius: '0 0 4px 0px',
  },
  containerPreview: {
    display: 'flex',
    alignItems: 'center',
    width: 'calc(100% - 2px)',
    padding: '10px 10px 6px',
    backgroundColor: '#FFFFFF',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
    boxSizing: 'border-box',
  },
  selectPreview: {
    width: 280,
  },
  scoreRow: {
    fontSize: 14,
  },
  discrepancy: {
    color: '#d32f2f',
    fontWeight: 'bold',
    fontSize: 14,
    marginTop: 4,
    marginBottom: 4,
  },
  formRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    marginTop: 10,
  },
  select: {
    width: '100%',
    margin: '10px 0',
  },
  button: {
    margin: '5px 0',
  },
  noDiscrepancy: {
    color: '#2e7d32',
    fontWeight: 'bold',
    fontSize: 14,
    marginTop: 4,
    marginBottom: 2,
  },
});
